module.exports = __webpack_public_path__ + "public/images/explore-history.df5ad2bbab3aa9a5bcd5a669e3faa783.jpg";